require('angular/customer_application_bootstrap');
require('./components');
require('./router.js');
require('angular/libs/neuro_id/neuroid_3.js')
